const apiConfig = {
    laropay: {
        baseUrl: "https://api.php90games.com"
    },
    sandbox: {
        baseUrl: "https://sandbox.api.laropay.net"
    }
}

export const getLaropayBaseUrl = () => {
    return process.env.REACT_APP_ENV === 'development' ? apiConfig.sandbox.baseUrl : apiConfig.laropay.baseUrl;
}

export const getGateSC = (gate) => {
    switch (gate) {
        case "quezon":
            return "qz"
            break;
        case "davao":
            return "dv";
            break;
        case "manila":
            return "mn";
            break;
        default:
            return "test";
            break;
    }
}